module.exports = __webpack_public_path__ + "img/uid-login.7c6c1f7f.png";